export default "__VITE_ASSET__BRMp_yqU__"